import { Component, OnInit } from '@angular/core';
import { GlobalVars } from '../../../providers/globalVars';
import * as firebase from 'firebase/app';
@Component({
  selector: 'app-test',
  templateUrl: './test.page.html',
  styleUrls: ['./test.page.scss'],
})
export class TestPage implements OnInit {
  datenow: any = new Date().getTime();
  constructor(public gv:GlobalVars) { }

  ngOnInit() {
    //this.test();
    //setTimeout(_=>{this.test()},1200)
  }

  test(){
    this.gv.uid = 'jP0HZFCrBfdsESULHclCfyeqSnE2';
    firebase.database().ref('/userData/' + this.gv.uid + '/favlist').once('value').then(fav => {
                if (!this.gv.norefresh) {
                  let temp = [];
                  let templist = [];
                  let boardtemp = [];
                  let count = 0;
                  
                  if (fav.val()) {
                    let favlist = [];
                    fav.forEach(favitem=>{temp.push(favitem.val().chid); favlist.push(favitem.val())})
                    count = Math.ceil(temp.length/10);
                    for(let i = 0; i < count; i++)
                    {
                    firebase.firestore().collection('channel')
                    .where(firebase.firestore.FieldPath.documentId(),'in',temp.slice((i*10),(i+1)*10))
                    .get().then(rst=>{
                      rst.docs.forEach(d=>{
                        let favdata = d.data();
                        let _fav = favlist.filter(f=>{return f.chid==d.id})?favlist.filter(f=>{return f.chid==d.id})[0]:[];
                        _fav.title = favdata.name;
                        _fav.img = favdata.imagethumb && favdata.imagethumb[0] && favdata.imagethumb[0].url ? favdata.imagethumb[0].url : null;
                        _fav.isMine = favdata.userId == this.gv.uid;
                        _fav.lastposting = favdata.recent ? favdata.recent : ''
                        this.gv.ufavlist.push(_fav);
                      })
                    })

                    firebase.firestore().collection('post')
                    .where('categoryId','in',temp.slice((i*10),(i+1)*10))
                    .orderBy('createdDate')
                    .limitToLast(30)
                    .get().then(rst=>{
                      rst.docs.forEach(d=>{
                    //_item = { $key: data.$key, rcreatedDate: data.rcreatedDate, data: rst.val(), haveread: false };
                    //             recentlist.forEach(recent => {
                    //               if (recent.itemid == rst.key) {
                    //                 _item.haveread = true;
                    //               }
                    //             });
                    //             boardlisttemp.push(_item);
                        this.gv.boardlist.push(
                          { $key: d.id, rcreatedDate: d.data().createdDate, data: d.data(), haveread: false }
                        )
                          //d.data());
                      })
                    }).then(_=>{
                      if(i == (count-1))
                      {
                        //this.gv.boardlist = this.orderby.transform(boardlisttemp, 'rcreatedDate', 'desc').slice(0, 30)
                        this.gv.storeOnStorage('listdata', this.gv.boardlist);
                        console.log(this.gv.boardlist);
                        
                        this.gv.boardlistpage = Math.ceil(this.gv.boardlist.length / 6)
                        this.gv.loadingboard = false;
                        console.log('로딩끝')
                        
                        
                        // this.gv.storeOnStorage('ufavlist', this.gv.ufavlist);
                        // this.gv.loadedfav = true;
                        // this.gv.chkchannelvisit();
                      }
                    })
                    }
                  }

                }})
  }

}
